import { useTranslation } from 'react-i18next'
import { Printer } from 'lucide-react'
import { ReadIconAction } from './ReadIconAction'

/**
 * Read mode's only chrome: a print button that triggers the browser's
 * native print dialog. Hidden when printed — a printed page has no use for
 * buttons. There is no "back to standard view" link: the public site only
 * ever shows the article (read-mode) view, so there is no other view to
 * return to.
 *
 * Icon-only and round, like the share controls it sits next to: the label is
 * carried by `aria-label`/`title` and shown on hover or focus only.
 *
 * Rendered by `ReadArticleHeader` alongside the kicker rather than on its own
 * row, so layout (alignment, spacing) is the parent's call — this component
 * only owns the button itself.
 */
export function ReadModeToolbar() {
  const { t } = useTranslation()

  return (
    <ReadIconAction label={t('read_mode.print')} onClick={() => window.print()}>
      <Printer className="h-4 w-4" />
    </ReadIconAction>
  )
}
